<div class="layout-column">
  <span class="mat-dialog-title" style="text-align: center;">{{titleText}} Storage Box</span>
  <form [formGroup]="storageBoxForm" class="form-group" style="width: 100%">
    <div class="layout-column">
      <mat-form-field>
        <mat-label>{{getFieldDisplayName(standardFields.name.canonical_name)}}</mat-label>
        <input matInput [required]="true" type="fieldTypes.SHORT_TEXT_AREA.input_type"
          maxlength="fieldTypes.SHORT_TEXT_AREA.max_length" formControlName="{{standardFields.name.canonical_name}}"
          [formGroup]="storageBoxForm" (keydown.enter)="$event.preventDefault()" pattern=".*\S.*">
          @if (storageBoxForm.get(standardFields.name.canonical_name).hasError('required') && storageBoxForm.get(standardFields.name.canonical_name).touched) {
            <mat-error>This field is required</mat-error>
          }
          @if (storageBoxForm.get(standardFields.name.canonical_name).hasError('maxlength')) {
            <mat-error>This is too long</mat-error>
          }
          @if (storageBoxForm.get(standardFields.name.canonical_name).hasError('pattern')) {
            <mat-error>Whitespace characters not allowed</mat-error>
          }
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{getFieldDisplayName(standardFields.description.canonical_name)}}</mat-label>
        <textarea matInput [required]="false" type="fieldTypes.LONG_TEXT_AREA.input_type"
          maxlength="fieldTypes.LONG_TEXT_AREA.max_length" formControlName="{{standardFields.description.canonical_name}}"
          cdkTextareaAutosize #autosize="cdkTextareaAutosize"
          [formGroup]="storageBoxForm" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="7"></textarea>
      </mat-form-field>
      @if (storageBoxForm.get(standardFields.description.canonical_name).hasError('maxlength')) {
        <mat-error>This is too long</mat-error>
      }
      <div>
        <mat-checkbox formControlName="{{spaceField.canonical_name}}" [formGroup]="storageBoxForm"></mat-checkbox>
        <span style="margin-left: 10px;">Space?</span>
      </div>
      <div class="layout-row" style="align-items:center; gap:8px; margin-top: 8px;">
        <ah-barcode-input (valueChange)="onChange($event)" placeholder="Storage Box Barcode" [disable]="false" formControlName="{{standardFields.barcode.canonical_name}}" [controlName]="standardFields.barcode.canonical_name" [group]="storageBoxForm" #input>
        </ah-barcode-input>
      </div>
        @if (barcodeError) {
          <mat-error class="barcode-error">Storage Box Barcode {{barcodeName}} already exists</mat-error>
        }
    </div>
    <div class="layout-column" id="form-right-column">
      <div class="input-wrapper-p-dropdown">
        <p-select appendTo="body" formControlName="{{standardFields.warehouseLocation.canonical_name}}" placeholder="{{getFieldDisplayName(standardFields.warehouseLocation.canonical_name)}}"
          [options]="warehouseLocationOptions$ | async" (onChange)="selectWarehouseLocation($event.value)"
        [formGroup]="storageBoxForm" [filter]="!(deviceService.isMobile() || deviceService.isTablet())" [virtualScroll]="true" [virtualScrollItemSize]="30"></p-select>
      </div>
      @if (storageBoxForm.get(standardFields.warehouseLocation.canonical_name).hasError('required') && storageBoxForm.get(standardFields.warehouseLocation.canonical_name).touched) {
        <mat-error>This field is required</mat-error>
      }
      <div class="input-wrapper-p-dropdown">
        <p-select appendTo="body" formControlName="{{standardFields.warehouseSubLocation.canonical_name}}" placeholder="{{getFieldDisplayName(standardFields.warehouseSubLocation.canonical_name)}}"
        [options]="warehouseSubLocationOptions$ | async" [formGroup]="storageBoxForm" [filter]="!(deviceService.isMobile() || deviceService.isTablet())" [virtualScroll]="true" [virtualScrollItemSize]="30"></p-select>
      </div>
      <mat-form-field>
        <input matInput placeholder="{{getFieldDisplayName(standardFields.shelf.canonical_name)}}" [required]="false" type="fieldTypes.SHORT_TEXT_AREA.input_type"
          maxlength="fieldTypes.SHORT_TEXT_AREA.max_length" formControlName="{{standardFields.shelf.canonical_name}}"
          [formGroup]="storageBoxForm">
      </mat-form-field>
      @if (storageBoxForm.get(standardFields.shelf.canonical_name).hasError('maxlength')) {
        <mat-error>This is too long</mat-error>
      }
      @if (storageBoxForm.get(standardFields.shelf.canonical_name).hasError('pattern')) {
        <mat-error>Whitespace characters not allowed</mat-error>
      }
    </div>
  </form>
  <div class="modal-buttons" style="padding: 8px;gap:20px;">
    <button mat-raised-button (click)="cancel()" color="default" type="button">
      Cancel
    </button>
    <button mat-raised-button color="primary" type="submit" (click)="submit()" [disabled]="storageBoxForm.invalid || barcodeError || barcodeChecking || !barcodeValid" class="save-button-padding">
      {{ barcodeChecking ? 'Checking...' : saveText }}
    </button>
  </div>
</div>
